export default __webpack_public_path__ + "static/media/client-05.69ea42b8.webp";